

import { useQuery } from "@tanstack/react-query";
import type { StoreAdminDetailResponse } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

type UseStoreByIdQueryParams = {
  storeId: string;
};

export function useStoreByIdQuery({ storeId }: UseStoreByIdQueryParams) {
  const query = useQuery({
    queryKey: queryKeys.admin.storeById(storeId),
    queryFn: () => apiJsonClient<StoreAdminDetailResponse>(endpoints.admin.storeById(storeId)),
    enabled: storeId.length > 0,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
